import { messageError } from '../../components/message';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import {
  IDownLoadConfig,
  IDownLoadConfigUpdate,
  IDownLoadMenu,
  IDownLoadVersionConfig,
  IDownLoadVersionMenu,
  IDownLoadVersionUpdateConfig,
  IDownloadRecord,
  IDownloadSyncEnvsBody,
} from '../../model/api-modules';
import { IDownloadCenterConfig } from '../../model/api-modules/download-center';
import { ADMIN_PREFIX } from '../config';

// 获取下载物列表
export const getDownLoadItems = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/object`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<Array<IDownLoadMenu>>(response, 'data');
      return res.sort((a, b) => {
        return a.CreateTime < b.CreateTime ? 1 : -1;
      });
    } catch (error) {
      return [];
    }
  });

// 创建下载物
export const createDownLoad = (body: IDownLoadConfig) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/object`;
      const response = await api.commonRequest('POST', url, {
        ...body,
      });
      await parsedResponse<IAPIresponse>(response, 'data');
      return true;
    } catch (error: any) {
      return false;
    }
  });

// 修改下载物
export const updateDownLoad = (id: number, body: IDownLoadConfigUpdate) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/object/${id}`;
      const response = await api.commonRequest('PUT', url, body);
      await parsedResponse<IAPIresponse>(response, 'data');
      return true;
    } catch (error: any) {
      return false;
    }
  });

// 删除下载物
export const delDownLoad = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/object/${id}`;
      const response = await api.commonRequest('DELETE', url);
      await parsedResponse<number>(response, 'data');
      return true;
    } catch (error: any) {
      return false;
    }
  });

// 获取下载物版本
export const getDownLoadVersionItems = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/version`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<Array<IDownLoadVersionMenu>>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return [];
    }
  });

// 配置项  --admin侧
export const getAdminDownloadCenterConfig = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/config`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IDownloadCenterConfig>(response, 'data');
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        messageError(err?.apiError?.message);
      }
      return null;
    }
  });

// 删除下载物版本
export const delDownLoadVersion = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/version/${id}`;
      const response = await api.commonRequest('DELETE', url);
      await parsedResponse<number>(response, 'data');
      return true;
    } catch (error: any) {
      return false;
    }
  });

// 创建下载物版本
export const createDownLoadVersion = (body: IDownLoadVersionConfig) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/version`;
      const response = await api.commonRequest('POST', url, body);
      await parsedResponse<IAPIresponse>(response, 'data');
      return true;
    } catch (error: any) {
      return false;
    }
  });

// 修改下载物版本
export const updateDownLoadVersion = (
  id: number,
  body: IDownLoadVersionUpdateConfig
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/version/${id}`;
      const response = await api.commonRequest('PUT', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });

// woa同步创建到cn，singapor
export const syncDownloadEnvs = (body: IDownloadSyncEnvsBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/version-sync-create-task`;
      const response = await api.commonRequest(
        'POST',
        url,
        body,
        {},
        6000000000
      );
      const res = await parsedResponse<IAPIresponse>(response, 'all');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });

// 获取下载记录
export const getDownLoadRecord = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/download-records?page=1&pageSize=100000`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IDownloadRecord>(response, 'data');
      return res;
    } catch (error) {
      return [];
    }
  });
